import { authPost } from "@api";
import { DEPLOYMENT_URL } from "@constants";

import { Integration, IntegrationBody } from "@pages/settings/types";
export const createIntegration = (
  deploymentId: string,
  integration: Integration,
  token: string
) => {
  let integrationBody: IntegrationBody = {
    ...integration,
    token,
  };
  return authPost<IntegrationBody, Integration>(
    `${DEPLOYMENT_URL}/${deploymentId}/integrations`,
    integrationBody
  );
};
